/**************************************************
 * Created by nanyuantingfeng on 11/07/2017 12:04.
 **************************************************/
import { Reducer } from '@ekuaibao/store'
import { app as api } from '@ekuaibao/whispered'
import { catchError as catchErr } from '@ekuaibao/lib/lib/lib-util'
import { showMessage, showModal } from '@ekuaibao/show-util'
import key from './key'
import { get } from 'lodash'
import { MoneyMath } from '@ekuaibao/money-math'
import { moneyStr2StandardMoneyValue } from '../../lib/misc'
// import { showModalForFollowWeChat } from './util/billUtils'
import { visit } from '@ekuaibao/helpers'
import { Fetch } from '@ekuaibao/fetch'

const reducer = new Reducer(key.ID, {
  billList: [],
  paidList: [],
  newBillList: [],
  newBillTableList: [],// 我的单据表格模式下的数据
  newPaidList: [],
  expenseSpecificationList: [],
  loanSpecificationList: [],
  requisitionSpecificationList: [],
  loanPackage: [],
  departments: [],
  balance: '',
  isLoading: false,
  isLoading_Save: false,
  requisitionInfo: [],
  voucherData: {},
  configRule: {},
  entityInfo: {},
  ref_dataLinkMap: {},
  checkedInvoiceItemsMap: [],
  dataLink: {},
  multiplePayeesMode: false,
  dataLinkEdit: {},
  feeTypeVisibleObjForModify: {},
  activeCreditRuleWithGroups: [], // 可用的信用批注选项
  billNotes: [], // 当前单据可见批注
  detailReadable: false, // 单据上的信用批注分数是否可见
  authorRemovable: false, // 允许信用批注的添加人删除该批注
  creditNoteAvailable: false, // 当前用户是否可以添加信用批注
  billNotesInHistory: [], //在单据历史中的批注快照
  showBillNotesInHistory: false, //用户是否在浏览单据历史
  myCreditPoint: {}, //个人信用分数据
  visibleFeeTypeByFormDataMap: undefined, // 当前可见的费用类型Map
  openTemplateModalDeta: {},
  travelBlackList: [], // 申请单行程是否可撤回
  dimentionCurrencyInfo: null, // 法人实体多币种
  loanLogs: {},
  requisitionDataSource: [],
  assiciationGroupData: {}, // 钉钉关联群数据
  feeChangeInfo: {}, // 费用变更
  skipCheck: null,
  isLinkRequisition: null,
  redirectToRequisition: false, // 是否从外部进入应用，跳转到申请事项详情
  billRiskWaring: {}, // 单据发票风险上的数据
  billsRateList: [], // 单据上本位币或者法人实体的汇率换算列表
  billsToRateList: {}, // 单据转换汇率列表
  myBillsOpenEntry: '', // 我的单据打开入口
  dataLinkEntity: [],
  validateError: { bill: [], detail: [], trip: [] },
  currentVisibleFeeTypes: []
})
//票据连号风险需要填写原因
reducer.handle(key.GET_INVOICE_REASON)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.SAVE_PAYEE)(
  catchErr((state, action) => {
    if (!action.isSetDefault) {
      showMessage.success(i18n.get('保存成功'))
    } else {
      showMessage.success(i18n.get('设置成功'))
    }
    return { ...state }
  })
)

reducer.handle(key.SET_PRINT_PREVIEW_URL)(
  catchErr((state, action) => {
    return { ...state, printPreviewUrl: action.url }
  })
)

reducer.handle(key.DEL_PAYEE)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.GET_DEPARTMENTS)(
  catchErr((state, action) => {
    let departments = action.payload.items
    return { ...state, departments }
  })
)

reducer
  .match(key.CAL_PLAN_INSTANCE)
  .pending((state, action) => {
    return { ...state, isLoading: true }
  })
  .handle((state, action) => {
    if (action.error) {
      showModal.error({
        title: i18n.get('送审失败'),
        content: action?.payload?.msg
      })
    }

    return { ...state, isLoading: false }
  })

reducer.match(key.SAVE_FLOW).handle(
  catchErr((state, action) => {
    let data = action.payload || {}
    const { billType = '' } = action
    let { value, type } = data
    if (value) {
      //提交失败
      let valueStr = value.split('\n')
      // todo 从展示dom元素，改为展示字符串；时间充裕时，需要改成按行渲染dom元素的形式
      let msgStr = ''
      valueStr.forEach(v => {
        msgStr += v
      })
      /*   if (type === 0) {
       showMessage.error(msgStr)
       } else {
       showMessage.info(msgStr)
       }*/
    } else {
      const { name, hiddenMsg } = action.mode
      if (name === 'freeflow.edit' || name === 'freeflow.editApproving') {
        if (!hiddenMsg) showMessage.success(i18n.get('保存成功'))
      } else {
        //目前都不弹框了
        //showMessage.success(i18n.get('提交成功'))
        // IS_ICBC:【工行e政务环境】申请单提交后不再弹出二维码弹窗
        // if (billType === 'requisition') {
        //   // 因平台限制，钉钉平台不能展示微信相关信息
        //   if (window.__PLANTFORM__ !== 'DING_TALK' && !IS_CMBC && !IS_ICBC) {
        //     showModalForFollowWeChat()
        //   }
        // }
        api.invokeService(`@common:get:backlog:count:approving`)
        api.invokeService(`@common:get:backlog:count:payment`)
        api.invokeService(`@common:get:backlog:count:sending`)
        api.invokeService(`@common:get:backlog:count:receiving`)

        if (name === 'freeflow.submit') {
          const { staff = {} } = api.getState()['@common'].userinfo
          const payByMutiMoney = get(data, 'flow.form.payPlanMode')
          const TotalAmount = get(data, 'flow.form.payMoney.standard')
          if (payByMutiMoney) {
            const payPlan = get(data, 'flow.form.payPlan')
            let amount = ''
            payPlan.forEach(el => {
              //@i18n-ignore
              amount += get(el, 'dataLinkForm.E_system_支付计划_支付金额.standard', 0) + '/'
            })
            //神策埋点
            window.TRACK &&
              window.TRACK('PaymentPlan', {
                staffId: staff.id,
                PlanCount: payPlan.length,
                TotalAmount,
                PlanAmount: amount
              })
          } else {
            let payByMutiDetails
            const details = get(data, 'flow.form.details', [])
            if (details.length > 0) {
              payByMutiDetails = !!details[0].feeTypeForm.feeDetailPayeeId
              if (payByMutiDetails) {
                let amount = ''
                details.forEach(el => {
                  amount += get(el, 'feeTypeForm.amount.standard', 0) + '/'
                })
                //神策埋点
                window.TRACK &&
                  window.TRACK('PaymentDetail', {
                    staffId: staff.id,
                    DetailCount: details.length,
                    TotalAmount,
                    DetailAmount: amount
                  })
              }
            }
          }
        }
      }
    }

    return { ...state }
  })
)

reducer
  .match(key.DEL_FLOW)
  .pending((state, _) => {
    return { ...state, isLoading: true }
  })
  .handle(
    catchErr((state, action) => {
      showMessage.success(i18n.get('删除的单据将进入回收站'))
      return state
    })
  )

reducer
  .match(key.RETRACT_FLOW)
  .pending((state, _) => {
    return { ...state, isLoading: true }
  })
  .handle(
    catchErr(
      state => {
        showMessage.success(i18n.get('单据撤回成功'))
        api.invokeService(`@common:get:backlog:count:approving`)
        api.invokeService(`@common:get:backlog:count:payment`)
        api.invokeService(`@common:get:backlog:count:sending`)
        api.invokeService(`@common:get:backlog:count:receiving`)
        return state
      },
      action => {
        let error = action.payload.msg || action.payload.message
        showModal.error({
          title: i18n.get('抱歉，无法执行撤回'),
          content: error,
          onOk() {
            api.emit('update:bill:list')
          }
        })
      }
    )
  )

reducer
  .match(key.COMMENT_FLOW)
  .pending((state, _) => {
    return { ...state, isLoading: true }
  })
  .handle(
    catchErr(
      state => {
        showMessage.success(i18n.get('单据评论成功'))
        return state
      },
      action => {
        let error = action.payload.msg || action.payload.message
        showModal.error({
          title: i18n.get('抱歉，无法评论'),
          content: error
        })
      }
    )
  )

//退票
reducer.handle(key.GET_WITHDRAW_FLOWID)(
  catchErr((state, action) => {
    return state
  })
)
reducer.handle(key.TRANSFER_FLOW)(
  catchErr((state, action) => {
    if (action.error) {
      showMessage.error(i18n.get('操作失败'))
      return state
    }
    showMessage.success(i18n.get('操作成功'))
    api.invokeService(`@common:get:backlog:count:approving`)
    api.invokeService(`@common:get:backlog:count:payment`)
    return { ...state }
  })
)

reducer
  .match(key.WITHDRAW_SAVE)
  .pending((state, _) => {
    return { ...state, isLoading: true }
  })
  .handle(
    catchErr(
      state => {
        showMessage.success(i18n.get('撤销支付成功'))
        return state
      },
      action => {
        let error = action.payload.msg || action.payload.message
        showModal.error({
          title: i18n.get('抱歉，无法撤销支付'),
          content: error
        })
      }
    )
  )

reducer.handle(key.CONFIRM_FLOW)(
  catchErr((state, action) => {
    showMessage.success(i18n.get('单据已确认完成'))
    return state
  })
)

reducer.handle(key.CONFIRM_FLOWS)(
  catchErr((state, action) => {
    showMessage.success(i18n.get('单据已确认完成'))
    return state
  })
)

reducer.handle(key.GET_ARCHIVES_FLOW)(
  catchErr((state, action) => {
    return { ...state, archivedFlows: action.payload }
  })
)

reducer.handle(key.FILTER_EXPENSE)((state, action) => {
  let keyword = action.payload
  let list = state.list.filter(item => {
    let key = keyword.toLowerCase()
    let title = item.form.title.toLowerCase()
    let orderCode = item.code ? item.code.toLowerCase() : ''
    return title.indexOf(key) >= 0 || orderCode.indexOf(key) >= 0
  })
  return { ...state, searchList: keyword.length > 0 ? list : undefined }
})

//#region image
reducer.handle(key.GET_UPLOAD_TOKEN)(
  catchErr((state, action) => {
    return state
  })
)
reducer.handle(key.GET_ATTACHMENT_URL)(
  catchErr((state, action) => {
    return state
  })
)

reducer.handle(key.GET_FEETYPE_BY_ID)(
  catchErr((state, action) => {
    return state
  })
)
//#endregion

//writtenOffRecord
reducer.handle(key.GET_LOAN_PACKAGE_LIST)(
  catchErr((state, action) => {
    let loanPackage = action.payload || {}
    return { ...state, loanPackage }
  })
)

// loan paid
reducer.handle(key.GET_LOAN_PACKAGE_LIST_PAID)(
  catchErr((state, action) => {
    return state
  })
)

reducer.handle(key.GET_LOAN_PACKAGE_DETAIL_BY_ID)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.GET_LOAN_LOGS)(
  catchErr((state, action) => {
    let loanLogs = action.payload.value || {}
    return { ...state, loanLogs }
  })
)
//#region loanInfo reducer

reducer.handle(key.GET_LOAN_BALANCE)(
  catchErr((state, action) => {
    let balance = action.payload.value
    return { ...state, balance }
  })
)

reducer.handle(key.APPLY_REPAYMENT)(
  catchErr((state, action) => {
    return state
  })
)

reducer.handle(key.GET_REPAYMENTINFO)(
  catchErr((state, action) => {
    return state
  })
)

reducer.handle(key.HIDE_REPAYMENTINFO)(
  catchErr((state, action) => {
    return state
  })
)

reducer.handle(key.GET_BILL_INFO_BY_CODE)(
  catchErr((state, action) => {
    return state
  })
)

reducer.handle(key.GET_FLOW_INFO_BY_ID)(
  catchErr(
    (state, action) => {
      return { ...state }
    },
    info => {
      //临时方案：目前此接口对403不处理，使用Resource的统一的message提示
      const {
        payload: { status, msg, message }
      } = info
      if (status !== 403) {
        showMessage.error(message || msg)
      }
    }
  )
)

reducer.handle(key.GET_REPAY_APPLY_BY_STATUS)(
  catchErr((state, action) => {
    return state
  })
)

reducer.handle(key.GET_BANK_LIST)(
  catchErr((state, action) => {
    let data = action.payload || {}
    let budgetList = data.items || []
    return { ...state, budgetList }
  })
)

reducer.handle(key.GET_BUDGET_DETAIL)(
  catchErr((state, action) => {
    let budgetDetail = action.payload || {}
    return { ...state, budgetDetail }
  })
)

reducer.handle(key.GET_BUDGET_LIST)(
  catchErr((state, action) => {
    let budgetList = action.payload.items || []
    return { ...state, budgetList }
  })
)

reducer.handle(key.GET_FEETYPE_TEMPLATE_BY_ID)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.GET_FEETYPE_CALCULATE_FIELDS)(
  catchErr((state, action) => {
    let data = action.payload.items
    return { ...state, feetypeAutoCalulate: data }
  })
)

reducer.handle(key.GET_CITY_BY_KEY_WORD)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.SEARCH_MY_BILL_PAID_LIST)(
  catchErr((state, action) => {
    const paidList = action.payload.items
    return { ...state, paidList }
  })
)
reducer.handle(key.SEARCH_MY_PRINTREMIND_COUNT)((state, action) => {
  if (action.error) return state
  const { count = 0 } = action.payload
  return { ...state, printListCount: count }
})
reducer.handle(key.GET_EXPENSE_LINK)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.SEARCH_MY_FINISHED_BILL_LIST)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.REFRESH_APPLY_EVENT)(
  catchErr((state, action) => {
    const { applyList, applyListClosed } = state
    const { applyEvent } = action
    if (applyList?.length && applyEvent.state === 'PROCESS') {
      const index = applyList.findIndex(el => el.id === applyEvent?.id)
      if (index > -1) {
        applyList[index] = applyEvent
        return { ...state, applyList }
      }
    } else if (applyListClosed?.length && applyEvent.state !== 'PROCESS') {
      const index = applyListClosed.findIndex(el => el.id === applyEvent?.id)
      if (index > -1) {
        applyListClosed[index] = applyEvent
        return { ...state, applyListClosed }
      }
    }
  })
)


reducer.handle(key.GET_APPLY_EVENT)(
  catchErr((state, action) => {
    const { count = 0, items = [], value = {} } = action.payload
    // 当前来看此接口返回的数据结构是 value， 并不会返回 count items。
    // 之前 count 和 items 相关的逻辑处理不敢删，所以留着。
    // if (count > 0) {
    //   const applyList = items.filter(el => el.state === 'PROCESS')
    //   const applyListClosed = items.filter(el => el.state !== 'PROCESS')
    //   return {
    //     ...state,
    //     applyEventCount: count,
    //     applyListClosed,
    //     applyList
    //   }
    // }
    if (value?.id) {
      const { requisitionInfo = [] } = state
      requisitionInfo.some(v => {
        if (v.id === value.id) {
          Object.assign(v, { ...value })
          return true
        }
        return false
      })
      return {
        ...state,
        requisitionInfo
      }
    } else {
      const applyList = items.filter(el => el.state === 'PROCESS')
      const applyListClosed = items.filter(el => el.state !== 'PROCESS')
      // 只要这些就可以了
      const requisitionInfo = applyList.map(item => ({
        "id": item.id,
        "name": item.name,
        "code": item.code,
        "title": item.title,
        "submitterId": item.submitterId,
        "ownerId": item.ownerId,
        "requisitionDate": item.requisitionDate,
        "requisitionMoney": item.requisitionMoney,
        "requisitionMoneyNode": item.requisitionMoneyNode
      }))
      return {
        ...state,
        applyEventCount: count,
        applyListClosed,
        applyList,
        requisitionInfo
      }
    }
  })
)

reducer.handle(key.GET_REQUISITION_DATA_SOURCE)(
  catchErr((state, action) => {
    let { requisitionDataSource = [] } = action.payload
    return { ...state, requisitionDataSource }
  })
)

reducer.handle(key.GET_APPLY_BY_EXPENSE)(
  catchErr((state, action) => {
    const expenseLink = action.expenseLink
    const expenseLinkList = Array.isArray(expenseLink) ? expenseLink : [expenseLink]
    let requisitionInfo = action.payload.items
    expenseLinkList.forEach(currentValue => {
      if (currentValue && currentValue.id && !requisitionInfo.find(v => v.id === currentValue.id)) {
        //当关联申请事项被关闭
        if (currentValue.state === 'PROCESS') {
          currentValue.label = currentValue.label || currentValue.name
        } else {
          currentValue.label = currentValue.label || i18n.get(`{__k0}（已关闭）`, { __k0: currentValue.name })
        }
        currentValue.disabled = true
        requisitionInfo.unshift(currentValue)
      }
    })
    return { ...state, requisitionInfo }
  })
)

reducer.handle(key.CHANGE_APPLY_EVENT)(
  catchErr((state, action) => {
    return { ...state }
  })
)
reducer.handle(key.GET_AUTO_CALCULATIO_RESULT)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.GET_CALCULATE_RECORD_LINK)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.GET_LOAN_PACKAGE_LIST_BY_ID)(
  catchErr((state, action) => {
    let loanPackageList = action.payload
    return { ...state, loanPackageList }
  })
)

reducer.handle(key.GET_OFFICIAL_CARD)(
  catchErr((state, action) => {
    const valuation = action.valuation
    let officialCardRecords = action.payload.items || []
    if (valuation) {
      officialCardRecords = officialCardRecords.filter(item => {
        const vItem = valuation[item.id]

        //目前将公务卡接口返回的数据手动转为本位币对象
        item.totalMoney = moneyStr2StandardMoneyValue(item.totalMoney)
        item.useBalance = moneyStr2StandardMoneyValue(item.useBalance)
        if (vItem) {
          item.useBalance = new MoneyMath(item.useBalance).minus(vItem.used).value
          return Number(new MoneyMath(item.useBalance).standMoney) !== 0
        } else {
          return true
        }
      })
    }

    return { ...state, officialCardRecords }
  })
)

reducer.handle(key.BILL_REMIND)(
  catchErr(state => {
    showMessage.success(i18n.get('催办成功'))
    return { ...state }
  })
)

reducer.handle(key.ALL_BILL_REMIND)(
  catchErr(state => {
    showMessage.success(i18n.get('催办成功'))
    return { ...state }
  })
)

reducer.handle(key.GET_APPLY_EVENT_DETAIL_LIST)(
  catchErr(state => {
    return { ...state }
  })
)
reducer.handle(key.GET_APPLY_BILL_DETAIL)(
  catchErr(state => {
    return { ...state }
  })
)
//凭证预览
reducer.handle(key.GET_VOUCHER_DATA)(catchErr((state, action) => ({ ...state, voucherData: action.payload.value })))

reducer.handle(key.GET_THIRD_PARTY_ORDER_DATA)(catchErr(state => ({ ...state })))

reducer.handle(key.GET_TRIPS_TEMPLATE)(catchErr(state => ({ ...state })))

reducer.handle(key.GET_DATA_LINK_EDIT)((state, action) => {
  let dataLinkEntity = action.payload?.items || []
  return { ...state, dataLinkEntity }
})

reducer.handle(key.GET_DATA_LINK_EDIT_ITEMS)(catchErr(state => ({ ...state })))

reducer.handle(key.GET_RELEVENT_MEMBERS)(
  catchErr(state => {
    return { ...state }
  })
)

reducer.handle(key.GET_RELEVENT_MEMBERS)(
  catchErr(state => {
    return { ...state }
  })
)

reducer.handle(key.GET_INPUT_INVOICE_DATA, (state, action) => {
  if (action.error) {
    showModal.error({ title: i18n.get('查验失败'), content: action.payload.msg })
  }
  return { ...state }
})
reducer.handle(key.GET_INPUT_INVOICE_CAPTCHA)(
  catchErr(state => {
    return { ...state }
  })
)
reducer.handle(key.GET_SPECIFICATIONS)(
  catchErr(state => {
    return { ...state }
  })
)
reducer.handle(key.GET_DIMENSION_BY_ID)((state, action) => {
  return state
})
reducer.handle(key.GET_FLOW_INFO_BY_CODE)(
  catchErr(state => {
    return { ...state }
  })
)
reducer.handle(key.TRANSFER_APPLY)(
  catchErr((state, action) => {
    if (action.error) {
      showMessage.error(i18n.get('转交失败'))
      return state
    }
    showMessage.success(i18n.get('转交成功'))
    return { ...state }
  })
)
reducer.handle(key.SHARE_APPLY)(
  catchErr((state, action) => {
    if (action.error) {
      showMessage.error(i18n.get('共享失败'))
      return state
    }
    let { forbinddenNum } = action.payload && action.payload.value
    if (forbinddenNum === 0) {
      showMessage.success(i18n.get('共享成功'))
    }
    return { ...state }
  })
)

reducer.handle(key.GET_DATALINK_CONFIGRULE)((state, action) => {
  let configRule = action.payload
  return { ...state, configRule }
})

reducer.handle(key.GET_DATALINK_ENTITY)((state, action) => {
  let entityInfo = action.payload
  return { ...state, entityInfo }
})

reducer.handle(key.UPDATE_DATALINK_INSTANCE)((state, action) => {
  let {
    dataLinkObj: { value = {}, reset }
  } = action
  if (reset) {
    return { ...state, ref_dataLinkMap: {} }
  }
  let { ref_dataLinkMap } = state
  let map = {}
  Object.values(value.feeTypeForm)
    .filter(item => !!item)
    .forEach(v => {
      const id = typeof v === 'object' ? v.id : v
      if (id) {
        let refCount = ref_dataLinkMap[id]
        if (!refCount && id) {
          refCount = 0
        }
        if (!map[id]) {
          //已经加过了，防止重复添加
          refCount += 1
        }
        ref_dataLinkMap[id] = refCount
        map[id] = id
      }
    })
  return { ...state, ref_dataLinkMap }
})

reducer.handle(key.UPDATE_DETAIL_DATALINK_INSTANCE)((state, action) => {
  let { details = [] } = action
  let { ref_dataLinkMap } = state
  details.forEach(line => {
    let map = {}
    Object.values(line.feeTypeForm)
      .filter(item => !!item)
      .forEach(v => {
        const id = typeof v === 'object' ? v.id : v
        let refCount = ref_dataLinkMap[id]
        if (!refCount && id) {
          refCount = 0
        }
        if (!map[id]) {
          //已经减过了，防止重复减
          refCount -= 1
        }
        ref_dataLinkMap[id] = refCount
        map[id] = id
      })
  })
  return { ...state, ref_dataLinkMap }
})

reducer.handle(key.SAVE_REPAY_INFO)((state, action) => {
  let repayInfoTemp = action.payload
  return { ...state, repayInfoTemp }
})

reducer.handle(key.GENERATE_CONSUME_DETAILS)((state, action) => {
  let checkedInvoiceItemsMap = action.payload
  return { ...state, checkedInvoiceItemsMap }
})

reducer.handle(key.GET_INVOICE_CORPORATION)((state, action) => {
  let corporationList = action.payload
  return { ...state, corporationList }
})

reducer.handle(key.GET_INVOICE_DETAILALL_BYID)((state, action) => {
  return { ...state }
})

reducer.handle(key.SAVE_INVOICE_WAIT)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.DELETE_INVOICE_WAIT)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.ISSHOW_EBOT)((state, action) => {
  return { ...state }
})

reducer.handle(key.GET_OCR_LIST)(
  catchErr((state, action) => {
    return { ...state }
  })
)
reducer.handle(key.GET_OCR_OVERSEAS)(
  catchErr((state, action) => {
    return { ...state }
  })
)
reducer.handle(key.GET_FLOW_RISK_WARNING)(
  catchErr((state, action) => {
    return { ...state, billRiskWaring: action.payload }
  }))

reducer.handle(key.GET_FLOW_Single_RISK_WARNING)(
  catchErr((state, action) => {
    return { ...state }
  }))

reducer.handle(key.GET_CURRENT_FLOW_STATE)((state, action) => {
  return { ...state }
})

reducer.handle(key.GET_CURRENT_BACKLOG_BY_ID)((state, action) => {
  return { ...state }
})
reducer.handle(key.GET_DATALINK)((state, action) => {
  const { type2, payload } = action
  const { items } = payload || {}
  const { dataLink = {} } = state

  dataLink[type2] = items

  return { ...state, ...dataLink }
})

reducer.handle(key.GET_CYR_FZR_LIST)((state, action) => {
  return { ...state }
})

reducer.handle(key.SAVE_OCR_CARD_INFO)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.GET_INVOICE_IMG_BYID)((state, action) => {
  return { ...state }
})

reducer.handle(key.GET_INVOICE_IMG_BYFLOWID)((state, action) => {
  return { ...state }
})

reducer.handle(key.GET_INVOICE_INFO_BY_IDS)((state, action) => {
  return { ...state }
})

reducer.handle(key.GET_LEDGER_AND_PLAN_BY_ID)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.GET_LEDGER_RELATION_LIST)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.GET_INVOICE_ISDEDUCTIBLE)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.REFRESH_GET_NEW_DATA)(
  catchErr((state, action) => {
    const data = action.payload
    return { ...state, data }
  })
)

reducer.handle(key.SAVE_MULTIPLE_PAYEED)(
  catchErr((state, action) => {
    const data = action.payload
    return { ...state, ...data }
  })
)

reducer.handle(key.GET_DATALLINK_TEMPLATE_BYID)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.GET_DATALLINK_TEMPLATE_BYIDS)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.GET_RECORDLINK)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.GET_SUBMITTERLIST)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.GET_SHOW_BUDGET_TAB)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.GET_LOAN_PACKAGE_BY_FLOWID)(
  catchErr((state, action) => {
    return { ...state }
  })
)
reducer.handle(key.PUT_TRANSFER_LOAN_PACKAGE)(
  catchErr((state, action) => {
    showMessage.success(i18n.get('转交成功'))
    return { ...state }
  })
)

reducer.handle(key.GET_CALCULATE_FIELD)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.GET_ASSIGNMENT_RULE_BY_ID)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.GET_STAFF_BY_ID)(
  catchErr((state, action) => {
    return { ...state }
  })
)
reducer.handle(key.GET_FEETYPE_LIST_BY_FORMDATA)(
  catchErr((state, action) => {
    const currentVisibleFeeTypes = action.payload.items
    let visibleFeeTypeByFormDataMap = undefined
    if (currentVisibleFeeTypes.length) {
      visibleFeeTypeByFormDataMap = {}
      visit(currentVisibleFeeTypes, node => {
        visibleFeeTypeByFormDataMap[node.id] = node
      })
    }
    return { ...state, currentVisibleFeeTypes, visibleFeeTypeByFormDataMap }
  })
)
reducer.handle(key.EXPORT_APPORTION)(
  catchErr((state, action) => {
    return { ...state }
  })
)
reducer.handle(key.EXPORT_PLANPAY)(
  catchErr((state, action) => {
    return { ...state }
  })
)
reducer.handle(key.VALIDATE_ERROR)(
  catchErr((state, action) => {
    const validateError = { ...state.validateError, ...action.payload }
    return { ...state, validateError }
  })
)

reducer.handle(key.GET_SHARE_LIST_API)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.CHECK_LOAN_PACKAGE_EXIST)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.SAVE_FEETYPE_VISIBLE_LIST)(
  catchErr((state, action) => {
    const { feeTypeVisibleObjForModify } = action
    return { ...state, feeTypeVisibleObjForModify }
  })
)

reducer.handle(key.GET_FIELDS_GROUP_DATA)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.MODIFY_FEEDETAIL_TAXINFO)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.GET_ACTIVE_CREDIT_RULES_GROUP)(
  catchErr((state, action) => {
    const creditNoteAvailable = get(action, 'payload.value.creditNoteAvailable', false)
    const activeCreditRuleWithGroups = get(action, 'payload.value.ruleWithGroups', [])
    return { ...state, activeCreditRuleWithGroups, creditNoteAvailable }
  })
)

reducer.handle(key.GET_BILL_NOTES)(
  catchErr((state, action) => {
    const billNotes = get(action, 'payload.value.items', [])
    const detailReadable = get(action, 'payload.value.detailReadable', false)
    const authorRemovable = get(action, 'payload.value.authorRemovable', false)
    return { ...state, billNotes, detailReadable, authorRemovable }
  })
)

reducer.handle(key.POST_ADD_NOTE)(
  catchErr((state, action) => {
    setTimeout(() => api.invokeService('@bills:get:bill:notes', { flowId: action.flowId }))
    showMessage.success(i18n.get('添加成功'))
    return { ...state }
  })
)

reducer.handle(key.GET_MY_CREDIT_POINT)((state, action) => {
  const myCreditPoint = get(action, 'payload.value', {})
  const { submitterId } = action
  return { ...state, myCreditPoint: { ...myCreditPoint, submitterId } }
})

reducer.handle(key.SEARCH_NOTE_FORM_HISTORY)(
  catchErr((state, action) => {
    const billNotesInHistory = get(action, 'payload.value.items', [])
    return { ...state, billNotesInHistory, showBillNotesInHistory: true }
  })
)

reducer.handle(key.CHANGE_STATUS_OF_SHOWBILLNOTESINHISTORY)(
  catchErr((state, action) => {
    const { showBillNotesInHistory } = action
    return { ...state, showBillNotesInHistory }
  })
)

reducer.handle(key.GET_ALIPAY_INVOICE_LIST)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.GET_ALIPAY_INVOICE_DETAIL)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.GET_RETRY_CHECKER_INVOICE)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.IS_OPEN_TEMPLATE_MODAL)(
  catchErr((state, action) => {
    const data = get(action, 'payload', {})
    return { ...state, openTemplateModalDeta: data }
  })
)

reducer.handle(key.SAVE_WRITTENOFF_SUMMARY)(
  catchErr((state, action) => {
    return { ...state, writtenOffSummaryForMutiCurrency: action.writtenOffSummaryForMutiCurrency }
  })
)

reducer.handle(key.SAVE_WRITTENOFF_SUMMARY_FOR_CROSS)(
  catchErr((state, action) => {
    return { ...state, writtenOffSummaryForCrossCurrency: action.writtenOffSummaryForCrossCurrency }
  })
)

reducer.handle(key.CLEAR_WRITTENOFF_SUMMARY)(
  catchErr((state, action) => {
    return { ...state, writtenOffSummaryForMutiCurrency: null }
  })
)

reducer.handle(key.CLEAR_WRITTENOFF_SUMMARY_FOR_CROSS)(
  catchErr((state, action) => {
    return { ...state, writtenOffSummaryForCrossCurrency: null }
  })
)

reducer.handle(key.ACTIVATE_FLOW)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.GET_TRAVEL_BACK_INFO)(
  catchErr((state, action) => {
    return {
      ...state,
      // travelBackInfo: action.payload?.items || []
      travelBlackList: action.payload || []
    }
  })
)

reducer.handle(key.UPDATE_DIMENTION_CURRECY)(
  catchErr((state, action) => {
    return { ...state, dimentionCurrencyInfo: action.dimentionCurrencyInfo }
  })
)

reducer.handle(key.CHECK_RETURN_CITY)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.GET_PULLTRAVELORDERBYSTAFF)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.SAVE_AIFAPIAO_AUTHORIZE)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.HANDLE_INVOICE_IMPORT)(
  catchErr((state, action) => {
    return { ...state }
  })
)
reducer
  .match(key.NULLIFY_FLOW)
  .pending((state, _) => {
    return { ...state, isLoading: true }
  })
  .handle(
    catchErr((state, action) => {
      showMessage.success(i18n.get('单据作废成功'))
      return state
    })
  )

reducer.handle(key.GET_NULLIFY_RULE_BYSPECID)(
  catchErr((state, action) => {
    return state
  })
)

reducer.handle(key.GET_NULLIFY_RULE_BY_FLOWID)(
  catchErr((state, action) => {
    return state
  })
)

reducer.handle(key.LOAN_RULE_CONFIG_LIST)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.GET_ASSOCIATION_GROUP_DATA)(
  catchErr((state, action) => {
    const assiciationGroupData = action?.payload?.value
    return { ...state, assiciationGroupData }
  })
)
reducer.handle(key.AUTO_GENERATION_FEE_DETAIL_RULES)((state, action) => {
  return { ...state }
})

reducer.handle(key.AUTO_GENERATION_FEE_DETAIL)((state, action) => {
  return { ...state }
})

reducer.handle(key.GET_CURRENCY_RATES_BYID)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.SET_CURRENCY_RATES)(
  catchErr((state, action) => {
    let data = action?.payload?.items || []

    return { ...state, billsRateList: data }
  })
)

reducer.handle(key.GET_CURRENCY_CONFIG)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.GET_ACTIVE_ACCOUNT_LIST)((state, action) => {
  return { ...state }
})

reducer.handle(key.GET_SURPLUS_RESULT)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.GET_TRAVEL_RESULT)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.GET_LAYOUT_CONFIG)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.GET_OWNER_REMAIN)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.SEARCH_EXTENSION_CENTER_CONFIG)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.POST_DISABLE_INVOICE)((state, action) => {
  return { ...state }
})

reducer.handle(key.POST_MARK_INVOICE)((state, action) => {
  return { ...state }
})

reducer.handle(key.GET_DISABLE_STATE_BY_INVOICEID)((state, action) => {
  return { ...state }
})

reducer.handle(key.GET_FEE_TYPE_CHANGE)(
  catchErr((state, action) => {
    const result = action?.payload?.items || []
    const feeChangeInfo = {}
    result.forEach((item, index) => {
      const key = item.feeTypeId
      feeChangeInfo[`${key}${index}`] = item
    })
    return {
      ...state,
      feeChangeInfo
    }
  })
)

reducer.handle(key.GET_DEFAULT_PAYEE)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.GET_DELEGATE_CONFIG)(
  catchErr((state, action) => {
    return { ...state }
  })
)

reducer.handle(key.SET_SUBMITTER_DATA)(
  catchErr((state, action) => {
    return { ...state, submitterData: action.submitterData }
  })
)

reducer.handle(key.GET_CAlCULATE_CORP_ID_WHITELIST)((state, action) => {
  return { ...state, skipCheck: action.payload.value }
})

reducer.handle(key.GET_LINK_REQUISITION_COPRS)((state, action) => {
  const isLinkRequisition = (action.payload.items || []).filter(ii => ii === Fetch.ekbCorpId).length !== 1
  return { ...state, isLinkRequisition }
})

reducer.handle(key.GET_IF_DOWNLOAD_NEED_FILENAME)((state, action) => {
  return { ...state, needDownloadFileName: action?.payload?.value }
})

reducer.handle(key.SAVE_HISTORY_CURRECY_RATES)(
  catchErr((state, action) => {
    return { ...state, historyCurrencyInfo: action.historyCurrencyInfo }
  })
)

reducer.handle(key.SAVE_MALL_REDIRECT_PARAMS)(
  catchErr((state, action) => {
    return { ...state, mallRedirectParams: action.mallRedirectParams }
  })
)

reducer.handle(key.SAVE_REQUISITION_REDIRECT_STATUS)(
  catchErr((state, action) => {
    return { ...state, redirectToRequisition: action.redirectToRequisition }
  })
)

reducer.handle(key.GET_MY_BILLS)(
  catchErr((state, action) => {
    return { ...state, newBillList: action.newBillList }
  })
)

reducer.handle(key.GET_MY_BILLS_TABLE)(
  catchErr((state, action) => {
    return { ...state, newBillTableList: action.newBillTableList }
  })
)

reducer.handle(key.GET_MY_BILLS_ENTRY)(
  catchErr((state, action) => {
    return { ...state, myBillsOpenEntry: action.myBillsOpenEntry }
  })
)

reducer.handle(key.Clear_FLOW_RISK_WARNING)(
  catchErr((state, action) => {
    return { ...state, billRiskWaring: action.payload }
  }))

export default reducer
